import React from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import LabelField from './LabelField'
import '../css/react-datepicker.css'
import fr from 'date-fns/locale/fr'

registerLocale('fr', fr)

const DatePicker = ({ label, subLabel, direction, className, ...props }) => {
  return <LabelField label={ label } subLabel={ subLabel } className={ className } direction={ direction }>
    <ReactDatePicker { ...props } locale='fr'/>
  </LabelField>
}

export default DatePicker
